import AllSpot from './AllSpot'

export default AllSpot
